import { LoadPatientPendencies } from 'domain/usecases/patient/load-patient-pendencies'
import { PatientRepository } from 'repository/interfaces/patient-repository'

export class RemoteLoadPatientPendencies implements LoadPatientPendencies {
  constructor(private readonly patientRepository: PatientRepository) {}

  load(
    params: LoadPatientPendencies.Params
  ): Promise<LoadPatientPendencies.Model> {
    return this.patientRepository.loadPatientPendencies(params)
  }
}
